// Mock data for ORICO d.o.o. — equipment supplier & interior design company
import { uploadedPhotos } from "./data/uploadedPhotos";

export const features = [
  {
    id: 1,
    title: 'Uređenje',
    subtitle: 'interijera',
    desc: 'Cjelovita realizacija jedinstvenih interijera za sve vrste objekata.',
    dark: false,
  },
  {
    id: 2,
    title: 'Dobava',
    subtitle: 'opreme',
    desc: 'FF&E, OS&E i građevinski materijali za nove objekte i rekonstrukcije.',
    dark: true,
  },
  {
    id: 3,
    title: 'Realizacija',
    subtitle: 'projekata',
    desc: 'Od koncepta i planiranja do montaže i konačne primopredaje.',
    dark: false,
  },
];

export const whyItems = [
  { no: '01', title: 'Perfekcija detalja', desc: 'Najviši standardi kvalitete i preciznosti namještaja i opreme izrađene po narudžbi.' },
  { no: '02', title: 'Svjetski proizvođači', desc: 'Suradnja s vodećim svjetskim proizvođačima opreme, namještaja i materijala.' },
  { no: '03', title: 'Predanost klijentu', desc: 'Od jednog komada za apartman do cjelovitog uređenja interijera hotela.' },
];

// "We offer" — services
export const services = [
  { no: '01', title: 'Rješenja za interijer i eksterijer', desc: 'Realizacija interijera hotela, ureda, restorana, trgovina, wellnessa i privatnih rezidencija.' },
  { no: '02', title: 'Planiranje projekta', desc: 'Koordinacija i harmonizacija rada arhitekata, dizajnera i dobavljača u skladu sa željama investitora.' },
  { no: '03', title: 'Projektni inženjering', desc: 'Organizacija svih aspekata projekta unutar zadanog vremenskog rasporeda.' },
  { no: '04', title: 'Sinkronizacija dizajna', desc: 'Usklađivanje dizajna i materijala svih uključenih dobavljača.' },
  { no: '05', title: 'Izrada uzornih soba', desc: 'Transformacija nacrta i skica u funkcionalan namještaj i opremu.' },
  { no: '06', title: 'Izrada namještaja i opreme', desc: 'Izrada od drveta, metala, tkanine, stakla i ostalih ekskluzivnih materijala.' },
  { no: '07', title: 'Kontrola postave / montaže', desc: 'Nadzor da se radovi na objektu odvijaju sukladno zahtjevima klijenta.' },
];

// "We supply"
export const supplyItems = [
  { title: 'Namještaj od drveta', desc: 'Laminat, furnir i puno drvo.' },
  { title: 'Metalni namještaj', desc: 'Kovano željezo, inox i aluminij.' },
  { title: 'Tapecirani namještaj', desc: 'Sofe, klupe, stolice i fotelje.' },
  { title: 'Vrata', desc: 'Standardna, zvučno izolirana i protupožarna.' },
  { title: 'Staklo', desc: 'Pregrade, vrata, tuš stijenke i ogledala.' },
  { title: 'Sanitarna oprema', desc: 'Keramika, kade, tuš kabine, slavine, namještaj.' },
  { title: 'Kamen', desc: 'Prirodni i umjetni kamen te kameni furnir.' },
  { title: 'Podne obloge', desc: 'Parket, tapisoni, PVC, sportski i deco podovi.' },
  { title: 'Zidne obloge', desc: 'Tapete, zidne boje i dekorativne obloge.' },
  { title: 'Tekstil', desc: 'Zavjese, presvlake, posteljina i sjenila.' },
  { title: 'Rasvjeta', desc: 'Ugradna, zidna, stolna i nadgradna rasvjetna tijela.' },
  { title: 'Keramika', desc: 'Podna, zidna, bazenska, mozaici i terracotta.' },
  { title: 'Wellness i fitness', desc: 'Saune, parne kupelji, hidromasažni bazeni, sprave.' },
  { title: 'Okoliš i bilje', desc: 'Osmišljavanje okoliša i dobava mediteranskog bilja.' },
];

export const partners = [
  'PORCELANOSA', 'ROCA', 'VITRA', 'ANDREU WORLD', 'GANDIA BLASCO',
  'MARSET', 'ZUCCHETTI', 'HARVIA', 'ARPER', 'LEVANTINA', 'TON', 'STUA',
  'ETHIMO', 'FORBO', 'BOSSINI', 'LAMINAM', 'ITALGRANITI', 'RAMON SOLER',
  'SONIA', 'CASABATH', 'FLORIM',
];

const img = {
  a: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/31t8o2up_IMG_5175.jpeg',
  b: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/d1ce2nat_IMG_5180.jpeg',
  c: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/33fc22hm_IMG_5181.jpeg',
  d: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/uih14de5_IMG_5182.jpeg',
  e: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/hc4fbthi_IMG_5183.jpeg',
  f: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/n5z7o11k_IMG_5172.jpeg',
  g: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/98sc65fd_IMG_5173.jpeg',
  h: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/n5z7o11k_IMG_5172.jpeg',
  i: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/e6mvk14m_IMG_5174.jpeg',
  j: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/4ooad4eq_IMG_5176.jpeg',
  k: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/ojds2xc3_IMG_5177.jpeg',
};

// Decorative interior gallery
export const galleryImages = [
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/98sc65fd_IMG_5173.jpeg',
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/n5z7o11k_IMG_5172.jpeg',
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/e6mvk14m_IMG_5174.jpeg',
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/4ooad4eq_IMG_5176.jpeg',
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/ojds2xc3_IMG_5177.jpeg',
];

// "We have done" — realised projects
export const projects = [
  { id: 1, title: 'Hotel Rixos', location: 'Dubrovnik', category: 'Hoteli', image: img.h },
  { id: 2, title: 'Monte Mulini — wellness', location: 'Rovinj', category: 'Wellness', image: img.a },
  { id: 3, title: 'Grand hotel Lav', location: 'Split', category: 'Hoteli', image: img.f },
  { id: 4, title: 'Villa Lozica', location: 'Dubrovnik', category: 'Rezidencije', image: img.c },
  { id: 5, title: 'Poslovni centar Internacional', location: 'Zagreb', category: 'Poslovno', image: img.j },
  { id: 6, title: 'Restoran Passarola', location: 'Hvar', category: 'Restorani', image: img.b },
  { id: 7, title: 'Hotel Bellevue', location: 'Dubrovnik', category: 'Hoteli', image: img.i },
  { id: 8, title: 'Hotel Bonavia — wellness', location: 'Rijeka', category: 'Wellness', image: img.e },
  { id: 9, title: 'Rezidencija Vabriga Borghetto', location: 'Poreč', category: 'Rezidencije', image: img.d },
  { id: 10, title: 'Luxury penthouse', location: 'Opatija', category: 'Rezidencije', image: img.g },
  { id: 11, title: 'Banka Kovanica', location: 'Zagreb', category: 'Poslovno', image: img.k },
  { id: 12, title: 'Hotel Excelsior', location: 'Dubrovnik', category: 'Hoteli', image: img.f },
  { id: 13, title: 'Hotel Arupinum', location: 'Rovinj', category: 'Hoteli' },
  { id: 14, title: 'Resort Blue Wave', location: 'Malinska', category: 'Hoteli' },
  { id: 15, title: 'Hotel Villa Margaret', location: 'Porat/Malinska', category: 'Hoteli' },
  { id: 16, title: 'Hotel Baština', location: 'Poreč', category: 'Hoteli' },
  { id: 17, title: 'Villa Pilato', location: 'Vižinada', category: 'Rezidencije' },
  { id: 18, title: 'Villa Štala', location: 'Malinska', category: 'Rezidencije' },
  { id: 19, title: 'Villa Palatinum', location: 'Mošćenička Draga', category: 'Rezidencije' },
  { id: 20, title: 'Luxury apartment Rosa del Mar', location: 'Mošćenička Draga', category: 'Rezidencije' },
  { id: 21, title: 'Luxury apartment Duplex', location: 'Mošćenička Draga', category: 'Rezidencije' },
  { id: 22, title: 'Kastav No.1', location: 'Kastav', category: 'Rezidencije' },
  { id: 23, title: 'Dvorana Marino Cvetković', location: 'Opatija', category: 'Sport' },
  { id: 24, title: 'Tenis akademija', location: 'Umag', category: 'Sport' },
  { id: 25, title: 'Alvimedica', location: 'Dugopolje', category: 'Klinike' },
];

// Interior gallery grouped by facility type (showcase, not tied to specific projects)
export const gallery = [
  { category: 'Hoteli', images: [uploadedPhotos.hotelRoom.src, uploadedPhotos.stoneBathroom.src, img.d, img.e, img.b] },
  { category: 'Wellness', images: [uploadedPhotos.wellness.src, uploadedPhotos.sauna.src] },
  { category: 'Bazeni', images: [uploadedPhotos.poolTerrace.src, uploadedPhotos.poolLakeside.src, uploadedPhotos.poolCurved.src] },
  { category: 'Rezidencije', images: [uploadedPhotos.grayLivingRoom.src, uploadedPhotos.tallLivingRoom.src, uploadedPhotos.bedroom.src, img.c, img.g, img.i] },
  { category: 'Poslovno', images: [img.h] },
  { category: 'Restorani', images: [img.k] },
  { category: 'Eksterijeri', images: [uploadedPhotos.woodEntrance.src, uploadedPhotos.stoneEntrance.src] },
];

export const heroImage = uploadedPhotos.grayLivingRoom.src;
export const secondaryImage = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/33fc22hm_IMG_5181.jpeg';
export const interiorImage = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/hc4fbthi_IMG_5183.jpeg';

export const navLinks = [
  { key: 'home', label: 'Početna', path: '/' },
  { key: 'projects', label: 'Projekti', path: '/projekti' },
  { key: 'services', label: 'Usluge', path: '/usluge' },
  { key: 'contact', label: 'Kontakt', path: '/kontakt' },
];
